var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('g',{staticClass:"fibers"},[_c('g',{staticClass:"fiber-1-side-a"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"2","stroke":"green"},attrs:{"d":`M${_vm.svgPadding} ${_vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedA()} 
                 L${_vm.svgPadding + 116} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedA()
        } 
                 L${_vm.svgPadding + 116 + _vm.spreadXOffset} ${
          _vm.svgHeight / 2 - 4 * _vm.fiberHeight
        } 
                 L${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight}`}})]),(!(_vm.isPigtail === true))?_c('g',{staticClass:"fiber-1-side-b"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"2","stroke":"green"},attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight} 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + _vm.spreadXOffset)} ${
          _vm.svgHeight / 2 - 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 116)} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedB()
        } 
                  L${_vm.svgWidth - _vm.svgPadding} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedB()
        } `}})]):_vm._e(),_c('g',{staticClass:"fiber-2-side-a"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"2","stroke":"rgb(223, 168, 39)"},attrs:{"d":` M${_vm.svgPadding} ${_vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedA()} 
                  L${_vm.svgPadding + 116} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedA()
        } 
                  L${_vm.svgPadding + 116 + _vm.spreadXOffset} ${
          _vm.svgHeight / 2 + 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth / 2} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} `}})]),(!(_vm.isPigtail === true))?_c('g',{staticClass:"fiber-2-side-b"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"2","stroke":"rgb(223, 168, 39)"},attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + _vm.spreadXOffset)} ${
          _vm.svgHeight / 2 + 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 116)} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedB()
        } 
                  L${_vm.svgWidth - _vm.svgPadding} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedB()
        } `}})]):_vm._e()]),_c('g',{staticClass:"claddings"},[_c('g',{staticClass:"cladding-1-side-a"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"5","stroke":"#ccbe82"},attrs:{"d":` M${_vm.svgPadding + 55} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedA() + 1
        } 
                  L${_vm.svgPadding + 116} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedA() + 1
        } 
                  L${_vm.svgPadding + 116 + _vm.spreadXOffset} ${
          _vm.svgHeight / 2 - 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight} `}})]),(!(_vm.isPigtail === true))?_c('g',{staticClass:"cladding-1-side-b"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"5","stroke":"#ccbe82"},attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight} 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + _vm.spreadXOffset)} ${
          _vm.svgHeight / 2 - 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 116)} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedB() + 1
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 55)} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedB() + 1
        } `}})]):_vm._e(),_c('g',{staticClass:"cladding-2-side-a"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"5","stroke":"#ccbe82"},attrs:{"d":` M${_vm.svgPadding + 55} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedA() - 1
        } 
                  L${_vm.svgPadding + 116} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedA() - 1
        } 
                  L${_vm.svgPadding + 116 + _vm.spreadXOffset} ${
          _vm.svgHeight / 2 + 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth / 2 + 5} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} `}})]),(!(_vm.isPigtail === true))?_c('g',{staticClass:"cladding-2-side-b"},[_c('path',{staticStyle:{"fill":"none","stroke-width":"5","stroke":"#ccbe82"},attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + _vm.spreadXOffset)} ${
          _vm.svgHeight / 2 + 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 116)} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedB() - 1
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 55)} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedB() - 1
        } `}})]):_vm._e(),(_vm.isPigtail)?_c('g',{staticClass:"cladding-1-and-2-side-b"},[_c('path',{attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight} L${
          _vm.svgWidth - _vm.svgPadding
        } ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight}`,"fill":"none","stroke-width":"5","stroke":"#ccbe82"}}),_c('path',{attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} L${
          _vm.svgWidth - _vm.svgPadding
        } ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} `,"fill":"none","stroke-width":"5","stroke":"#ccbe82"}})]):_vm._e()]),_c('g',{staticClass:"cloak"},[_c('g',{staticClass:"cloak-side-a"},[_c('path',{attrs:{"d":` M${_vm.svgPadding + 55 + 5} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedA() + 2 - 1
        } 
                  L${_vm.svgPadding + 116 + 3} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedA() + 2 - 1
        } 
                  L${_vm.svgPadding + 116 + _vm.spreadXOffset} ${
          _vm.svgHeight / 2 - 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight} `,"fill":"none","stroke-width":"7","stroke":_vm.getCssColor(_vm.cableColor)}}),_c('path',{attrs:{"d":` M${_vm.svgPadding + 55 + 5} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedA() - 1
        } 
                  L${_vm.svgPadding + 116} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedA() - 1
        } 
                  L${_vm.svgPadding + 116 + _vm.spreadXOffset} ${
          _vm.svgHeight / 2 + 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth / 2 + 5} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} `,"fill":"none","stroke-width":"7","stroke":_vm.getCssColor(_vm.cableColor)}})]),(!_vm.isPigtail)?_c('g',{staticClass:"cloak-side-b"},[_c('path',{attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight} 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + _vm.spreadXOffset)} ${
          _vm.svgHeight / 2 - 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + 3)} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedB() + 2 - 1
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 55 + 5)} ${
          _vm.svgHeight / 2 - _vm.spreadYOffsetCalculatedB() + 2 - 1
        } `,"fill":"none","stroke-width":"7","stroke":_vm.getCssColor(_vm.cableColor)}}),_c('path',{attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + _vm.spreadXOffset)} ${
          _vm.svgHeight / 2 + 4 * _vm.fiberHeight
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 116 + 3)} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedB() - 2 + 1
        } 
                  L${_vm.svgWidth - (_vm.svgPadding + 55 + 5)} ${
          _vm.svgHeight / 2 + _vm.spreadYOffsetCalculatedB() - 2 + 1
        } `,"fill":"none","stroke-width":"7","stroke":_vm.getCssColor(_vm.cableColor)}})]):_vm._e(),(_vm.isPigtail)?_c('g',{staticClass:"cloak-side-b"},[_c('path',{attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight} L${
          _vm.svgWidth - (_vm.svgPadding + 5)
        } ${_vm.svgHeight / 2 - 4 * _vm.fiberHeight}`,"fill":"none","stroke-width":"7","stroke":_vm.getCssColor(_vm.cableColor)}}),_c('path',{attrs:{"d":` M${_vm.svgWidth / 2} ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} L${
          _vm.svgWidth - (_vm.svgPadding + 5)
        } ${_vm.svgHeight / 2 + 4 * _vm.fiberHeight} `,"fill":"none","stroke-width":"7","stroke":_vm.getCssColor(_vm.cableColor)}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }